export const uploadMediaGetId = (builder) => ({
    uploadMediaGetId: builder.mutation({
      query: (credentials) => {
        return {
          url: `/media_update/${localStorage.getItem('bsp'||'KARIX')}`,
          method: 'POST',
          body: credentials,
        };
      },
    }),
  });